export default __webpack_public_path__ + "static/media/datos1.efb4f148.jpg";